<template>
  <component
    class="container"
    :class="{ active }"
    :is="componentType"
    :ghost="!active"
    :disabled="disabled"
    :to="to && !active ? to : null"
    v-on="active ? {} : { click: onClick }"
  >
    <icon
      v-if="showIcon"
      :class="{ highlight }"
      :icon="icon"
      size="tiny"
    />
    <span class="button-text"><slot /></span>
    <component
      class="iconCTA"
      :is="ctaComponentType"
      :ghost="active"
      :aria-label="label"
      v-on="active ? { click: onClick } : {}"
    >
      <icon :icon="ctaIcon" size="small" />
    </component>
  </component>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      default: 'soho'
    },
    highlight: {
      type: Boolean,
      default: false
    },
    iconCTA: {
      type: String,
      default: 'forward-ios'
    },
    label: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    componentType () {
      return this.active ? 'div' : 'sh-button-deprecated'
    },
    ctaComponentType () {
      return this.active ? 'sh-button-deprecated' : 'div'
    },
    ctaIcon () {
      return this.disabled ? 'checkbox-disabled' : this.iconCTA
    }
  },
  methods: {
    onClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss" scoped>

button {
  cursor: pointer;
}

.container {
  display: flex;
  justify-content: space-between;

  .inner-link {
    display: inline-flex;
    align-items: center;
    margin: 0;
  }

  .icon {
    display: block;
  }

  span {
    flex-grow: 1;
  }
}

.container {
  width: 100%;
  height: $d-large;
  align-items: center;
  padding: $d-xx-small $d-xx-small $d-xx-small $d-x-small;
  background-color: $color-white;
  @include border-small;
  @include deprecated-f-color-dark;
  @include transition-fast;

  .icon {
    display: block;
    @include transition-fast;
    fill: $deprecated-grey-medium-light;

    &.highlight {
      fill: $deprecated-brand-secondary;
    }
  }

  span {
    margin: 0 $d-small 0 $d-x-small;
    text-align: left;
    @include deprecated-f-color-dark;
    @include font('040');
  }

  .iconCTA {
    margin: 0;
    padding: 0;
  }

  &.active {
    background-color: #eaf3f9;
    box-shadow: inset 0 0 0 2px #e0ecf4;

    .icon {
      fill: $deprecated-brand-secondary;
    }

    span {
      @include deprecated-f-color-highlight;
    }

    button {
      display: flex;
    }
  }

  &[disabled] {
    background-color: $deprecated-grey-light;
    cursor: not-allowed;

    .icon {
      fill: $color-black;
    }

    .iconCTA .icon {
      padding: 4px;
    }
  }
}
</style>
